import { createContext, useContext } from 'react';

import type { IAiExtractionContextValue } from '#screens/ai-workbench/ai-extraction-context.js';

export interface WizardHilContextValue {
	/** The extraction context for the current wizard step. */
	extractionContext: IAiExtractionContextValue | null;
	/** Retrieve a previously stored HIL parse result by stable ID. */
	getResult: (id: string) => unknown;
}

export const WizardHilContext = createContext<WizardHilContextValue | null>(null);

/**
 * Returns the wizard HIL context, or null when rendered outside a wizard HIL workbench pane.
 */
export function useWizardHilContext(): WizardHilContextValue | null {
	return useContext(WizardHilContext);
}
